export default __webpack_public_path__ + "static/media/sa-img.1302e4de.png";